import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { EmployeesCollectionHeaderQuery } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import invitationsCollection from 'modules/employees/store/collections/invitations'

type EmployeesPending =
  EmployeesCollectionHeaderQuery['employees']['employeesNotInvited']['edges'][number]['node']

interface Props {
  isHidden: boolean
  employees: EmployeesPending[]
  onClose: () => void
}

const PendingModal = ({ isHidden, employees, onClose }: Props) => {
  const [selectedEmployeesIds, setSelectedEmployeesIds] = React.useState<number[]>([])

  if (isHidden) return null

  const handleClose = () => {
    setSelectedEmployeesIds([])
    onClose()
  }

  const handleSubmit = async () => {
    track(trackingEvents.employee.employeesResendInviteFinish)
    const { success } = await asyncAction(
      async () => {
        await invitationsCollection.rpc('bulk_invite', {
          accesses_ids: employees
            .filter((employee) => selectedEmployeesIds.includes(employee.id))
            .map((employee) => employee.access.id),
        })
      },
      { loadingMessage: i18n.t('employees.pending_invites_modal.loading_message') }
    )

    if (success) handleClose()
  }

  return (
    <Modal
      title={i18n.t('employees.pending_invites_modal.title')}
      description={i18n.t('employees.pending_invites_modal.description')}
      illustration="group"
      onSubmit={handleSubmit}
      onClose={handleClose}
      footer={<Button submit>{i18n.t('employees.pending_invites_modal.submit')}</Button>}
    >
      <EmployeeSelectorV2
        forcedFilters={{
          employeeIds: employees.map((employee) => employee.id),
        }}
        onChange={(state) => setSelectedEmployeesIds(state.type === 'manual' ? state.ids : [])}
        multiple
      />
    </Modal>
  )
}

export default PendingModal
